<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright1"><a id="page_iv"></a>NEW YORK UNIVERSITY PRESS<br/>New York and London</p>
<p class="copyright">Copyright ©1997 by New York University<br/>AD rights reserved</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright">Feldman, Stephen M., 1955–</p>
<p class="copyright2">Please don’t wish me a merry Christmas : A critical history of the<br/>separation of church and state / Stephen M. Feldman.</p>
<p class="copyright2a">p. cm.—(Critical America)</p>
<p class="copyright2">Includes bibliographical references and index.</p>
<p class="copyright2">ISBN 0-8147-2637-2 (alk paper)</p>
<p class="copyright2">1. Church and state—United States—Controversial literature.<br/>2. Christianity and antisemitism—United States. 3. Christianity<br/>and antisemitism—History. 4. United States—Church history—20th<br/>century. 5. United States—Politics and government—20th century.</p>
<p class="copyright3">I. Title.     II. Series..</p>
<p class="copyright3">BR516.F44     1997</p>
<p class="copyright3">322′.1’09—dc20               96-35601</p>
<p class="copyright3">                                            CIP</p>
<p class="copyright">New York University Press books are printed on acid-free paper,<br/>and their binding materials are chosen for strength and durability.</p>
<p class="copyright">Manufactured in the United States of America<br/>10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?4bff3422